module.exports = __webpack_public_path__ + "img/wei.77d053fe.jpg";